import React from "react";
import Header from "../component/Home/Header";
import AboutMiddleSection from "../component/About/AboutMiddleSection";
import AboutImages from "../component/About/AboutImages";
import AboutLocation from "../component/About/AboutLocation";
import AboutTab from "../component/About/AboutTab";
import AboutStory from "../component/About/AboutStory";
import AboutMission from "../component/About/AboutMission";
import AboutVision from "../component/About/AboutVision";
import AboutFooter from "../component/About/AboutFooter";
import Footer from "../component/Home/Footer";
import { useEffect } from "react";
import { updateMetaTagContent, updateTitle } from "../action/customFn";
import { Helmet } from "react-helmet-async";
import Brochure from "../component/Brochure/Brochure";

const DownloadBrochures = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="One Platform for students to become global certified professional. Apply for top courses, MGTIP programs, virtual internship & International remote Jobs."
        />
        <meta
          name="keywords"
          content="Global Training Courses, 
          Internship Program, 
          top courses,
           Virtual internship & training program,
          Global training & internship Program,
           MGTIP,
           virtual internship,
          International Jobs, 
          abroad virtual internship,
           Certification Courses,"
        />
        <title>
          MetBrains - Find Global Training Courses & Virtual Internship
        </title>

        <link rel="canonical" href="https://metbrains.com/about" />
      </Helmet>
      <Header />
      <Brochure />
      <Footer />
    </>
  );
};

export default DownloadBrochures;
